import React, { useEffect, useState } from 'react';
import { useOidc, useOidcUser } from '@axa-fr/react-oidc';
import LoadingModal from '../modal/LoadingModal';

const CallbackComponentWrapper = () => {
  const { isAuthenticated } = useOidc();
  const { oidcUser } = useOidcUser();
  const [hasRedirected, setHasRedirected] = useState(false);

  useEffect(() => {
    if (isAuthenticated && oidcUser && !hasRedirected) {
      setHasRedirected(true);
      const returnPath = sessionStorage.getItem('returnUrl') || '/admissions';
      window.location.replace(`${window.location.origin}/application${returnPath}`);
    }
  }, [isAuthenticated, oidcUser, hasRedirected]);

  return <LoadingModal />;
};

export default CallbackComponentWrapper;
